"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUserOnboardingExtraData = void 0;
class BaseUserOnboardingExtraData {
    constructor(value) {
        this.value = value;
    }
}
exports.BaseUserOnboardingExtraData = BaseUserOnboardingExtraData;
//# sourceMappingURL=BaseUserOnboardingExtraData.js.map